import { IFaqChannel } from '@/models/faqChannel.model';

export const getFaqChannelsOptions = (channels?: IFaqChannel[] | null) =>
  (channels ?? []).map((channel) => ({
    value: channel.channelId,
    label: channel.name ?? channel.slug,
  }));
